import React from 'react'

import { useSkeletonForFavorites } from 'src/features/SkeletonForFavorites/useSkeletonForFavorites'
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from 'src/components/shadcn/table'
import { Skeleton } from 'src/components/shadcn/skeleton'

export const SkeletonForFavorites = (): JSX.Element => {
  const { rows, cells } = useSkeletonForFavorites()

  return (
    <div className="mb-6">
      <Table className="w-full table-fixed">
        <TableBody>
          {rows.map(row => (
            <TableRow key={row}>
              {cells.map(cell => (
                <TableCell key={cell} className="p-2">
                  <Skeleton className="h-8 ml-2 w-full rounded animate-pulse" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
